import { render, staticRenderFns } from "./monthly_product_compare.vue?vue&type=template&id=5ce1f66a&scoped=true"
import script from "./monthly_product_compare.vue?vue&type=script&lang=js"
export * from "./monthly_product_compare.vue?vue&type=script&lang=js"
import style0 from "./monthly_product_compare.vue?vue&type=style&index=0&id=5ce1f66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce1f66a",
  null
  
)

export default component.exports